import angular from 'angular'

import component from './product-categories.component'

let module = angular.module('productCategories', [])

.component('productCategories', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/product-categories/index.js